import { apiClient } from "./client";
import type { LoginCredentials, LoginResponse } from "./types";

export async function loginWithBasicAuth(
  credentials: LoginCredentials,
): Promise<LoginResponse> {
  const encoded = btoa(`${credentials.username}:${credentials.password}`);

  const response = await apiClient.post<LoginResponse>("/security/login", [], {
    headers: {
      Authorization: `Basic ${encoded}`,
    },
  });

  return response.data;
}
